module.exports = __webpack_public_path__ + "img/logo-header.a7b9e101.png";